import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class AuthRoleGuard  {

  constructor(
  ) {}

  canLoad(): boolean | UrlTree {
    return true;
  }

  canActivate() {
    return true;
  }
}
